export default __webpack_public_path__ + "static/media/ic-facebook.0edb73eb.svg";